import api from './axios';

export const getAuditLogsApi = (params = {}) => api.get('/admin/audit-logs', { params });
export const getAuditStatsApi = () => api.get('/admin/audit-logs/stats/overview');
export const getRecentActivityApi = () => api.get('/admin/audit-logs/recent/activity');
